export default function Delete2Icon({
  className = '',
  style,
  onClick,
  onKeyDown,
  tabIndex,
  role,
  'aria-label': ariaLabel,
}) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
      style={style}
      onClick={onClick}
      onKeyDown={onKeyDown}
      tabIndex={tabIndex}
      role={role}
      aria-label={ariaLabel}
    >
      <path
        d="M12.0527 3.5L11.9971 4.0498L11.0879 13.1494C11.0112 13.9162 10.3653 14.5 9.59473 14.5H5.40527C4.63469 14.5 3.98885 13.9162 3.91211 13.1494L3.00293 4.0498L2.94727 3.5H12.0527Z"
        stroke="currentColor"
      />
      <rect x="1" y="3" width="13" height="1" rx="0.5" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 1.5C5 1.22386 5.22386 1 5.5 1H9.5C9.77614 1 10 1.22386 10 1.5C10 1.77614 9.77614 2 9.5 2H5.5C5.22386 2 5 1.77614 5 1.5Z"
        fill="currentColor"
      />
    </svg>
  );
}
